export const RESETPASSWORD_REQUESTING = 'RESETPASSWORD_REQUESTING'
export const RESETPASSWORD_SUCCESS = 'RESETPASSWORD_SUCCESS'
export const RESETPASSWORD_ERROR = 'RESETPASSWORD_ERROR'
export const RESETPASSWORD_URL = '/api/v1/users/confirm_reset_passwd'


// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/constants.js